<template>
  <div class="box">
    <div class="carousel-box">
      <div class="banner_title">只工作不上班</div>
      <div class="banner_content">人才共享服务平台 • 为1100万自由职业者提供一站式服务</div>
    </div>
    <div class="content-box">
      <div class="content_title">
        公司简介
      </div>
      <div class="content">
        <div class="content_left">
          杭州安略网络技术有限公司，成立于1998年06月01日，我们是一家专注于计算机网络技术和计算机硬件的技术开发、技术服务与技术咨询的高科技企业。
        </div>
        <img src="../assets/about/about2.png" alt="" class="content_right">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      // carouselImgList: [{ id: 0, imgSrc: require('@/assets/lunbo/banner1.jpg') }],
      // videoImg: [
      //   {
      //     pcImg: require('@/assets/newImg/别吃鸡/960x500.png'),
      //     mobileImg: require('@/assets/mobile/mobileVideo1.png')
      //   },
      //   {
      //     pcImg: require('@/assets/newImg/开心点点消.png'),
      //     mobileImg: require('@/assets/mobile/mobileVideo2.png')
      //   },
      //   {
      //     pcImg: require('@/assets/newImg/奔跑吧原始人.jpg'),
      //     mobileImg: require('@/assets/mobile/mobileVideo3.png')
      //   }
      // ],
      index: 1,
      BottomCurrentIndex: 0,
      windowWidth: document.documentElement.clientWidth
    }
  },
  methods: {
    bottomBtn(index) {
      this.BottomCurrentIndex = index
    },
    leftPlayIconBtn() {
      console.log(11)
      this.mutedOneShow = true
      this.$refs.videoOne.play()
    },
    topPlayIconBtn() {
      this.mutedTwoShow = true
      this.$refs.videoTwo.play()
    },
    bottomPlayIconBtn() {
      this.mutedThreeShow = true
      this.$refs.videoThree.play()
    },
    // moreBtn () {
    //   this.$router.push('/game')
    // },
    contactBtn() {
      this.$router.push('/contact')
    },
    downFn(item) {
      console.log(item)
      if (item.title !== '火星计划') {
        this.$message({
          showClose: true,
          message: '敬请期待',
          offset: 50,
          duration: 1000
        })
      } else {
        window.open('https://www.taptap.cn/app/378080', '_blank')
      }
      // else if{
      //   return window.open('https://h5pay.zdjoys.com/download/static/images/hxjh.apk', '_self');
      // }
      // if (document.documentElement.clientWidth < 992) {
      //     // return window.open('https://h5pay.zdjoys.com/download/static/images/hxjh.apk', '_self');
      //     return window.open('https://h5pay.zdjoys.com/download/static/images/hxjh.apk', '_self');
      //     // https://www.taptap.cn/app/378080
      //   }
      // this.dialogVisible = true
      // console.log(document.documentElement.clientWidth);
    },
    close() {
      this.dialogVisible = false
    }
  },
  watch: {
    // windowWidth: {
    //   handler (newVal, oldVal) {
    //     console.log(newVal, oldVal)
    //   }
    // }
  },
  created() {
    window.scrollTo(0, 0)
    console.log('出现');

    // console.log('window.innerWidth', windowWidth)
  }
}
</script>

<style lang="scss" scoped>
.box {
  padding: 75px 0 0 0;
}

// pc端
// @media (min-width: 992px) {
.display .imgbox {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

  .image {
    width: 200px;
    height: 200px;

    .img {
      width: 100%;
      height: 100%;
    }
  }
}

img {
  width: 100%;
  height: 100%;
}

// 轮播图

.carousel-box {
  // width: 1200px;
  // width: 1500px;
  margin: 0 auto;
  width: 1200px;
  height: 450px;
  background-image: url("../assets/about/aboutBanner.png");
  background-size: 100% 100%;
  color: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .banner_title {
    font-size: 75px;
  }

  .banner_content {
    font-size: 35px;
    margin-top: 23px;
  }
}

.content-box {
  margin-top: 120px;
  margin-bottom: 100px;
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 100px;
  .content_title {
    font-weight: bold;
    font-size: 38px;
    color: #3669FF;
    text-align: center;
    position: relative;
    margin: 38px 0 74px 0;
    &::after {
      content: "";
      display: block;
      position: absolute;
      width: 70px;
      height: 4px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #3669FF;
    }
  }

  .content {
    display: flex;
    justify-content: center;
    .content_left {
      font-size: 15px;
      color: #272727;
      width: 307px;
      height: 108px;
      margin-right: 49px;
      text-indent: 2em;
    }
    .content_right {
      width: 394px;
      height: 200px;
    }
  }
}

// }

// 移动端
// @media (max-width: 992px) {
//   img {
//     width: 100%;
//     height: 100%;
//   }

//   ::v-deep .el-carousel__button {
//     background-color: #ff8714;
//   }

//   .icon-title {
//     display: none;
//   }

//   //轮播图
//   .carousel-box {
//     .text-box-parent {
//       // z-index: -1;
//     }

//     ::v-deep .el-carousel__container {
//       // height: 250px !important;
//     }
//   }

//   .text-box-parent {
//     position: relative;

//     .text-box {
//       position: absolute;
//       // background-color: red;
//       z-index: 999;
//       top: 50%;
//       left: 69px;
//       transform: translateY(-50%);

//       .one {
//         font-size: 12px;
//         color: #191919;
//         margin-bottom: 5px;
//         font-weight: 500;
//       }

//       .two {
//         font-size: 14px;
//         color: #191919;
//         margin-bottom: 5px;
//         letter-spacing: 2px;
//         font-weight: 500;
//       }

//       .three {
//         text-align: center;
//         line-height: 30px;
//         width: 70px;
//         height: 30px;
//         background-color: #ff8714;
//         font-size: 12px;
//         color: #fff;
//         border-radius: 5px;
//         cursor: pointer;
//       }
//     }
//   }

//   .about {
//     @media (max-width: 992px) {
//       height: 250px;
//     }

//     display: flex;
//     justify-content: center;
//     // background-color: aqua;

//     .box {
//       padding: 20px 0 0 0;
//       text-align: center;
//       // width: 1200px;

//       .one {
//         // background-color: antiquewhite;
//         // text-align: center;
//         // background-color: aliceblue;
//         // line-height: 100px;
//         // width: 200px;
//         // height: 100px;

//         .title {
//           font-size: 20px;
//           color: #ff8714;
//           position: relative;

//           &::before {
//             content: ' ';
//             position: absolute;
//             display: block;
//             width: 5px;
//             height: 5px;
//             border-radius: 50%;
//             background-color: #ff8714;
//             top: 50%;
//             transform: translateY(-50%);
//             left: 36%;
//             // transform: translatex(-50%);

//           }

//           &::after {
//             content: ' ';
//             position: absolute;
//             display: block;
//             width: 5px;
//             height: 5px;
//             border-radius: 50%;
//             background-color: #ff8714;
//             top: 50%;
//             transform: translateY(-50%);
//             right: 36%;
//           }
//         }
//       }

//       .two {
//         color: #a7a7a7;
//         font-size: 20px;
//         font-family: Fontsstyle1;
//         font-weight: 300;
//         // letter-spacing: 2px;
//       }

//       .three {
//         margin: 5px 0;
//         font-size: 18px;
//         color: #000000;
//         // font-size: 32px;
//       }

//       .four {
//         display: none;
//       }

//       .mobile-four {
//         font-size: 12px;

//         .four-item {
//           text-align: center;
//           padding: 0 20px;
//           text-indent: 2em;
//           font-size: 12px;
//         }

//         .four-item:nth-child(2) {
//           margin: 10px 0;
//         }
//       }

//       .five {
//         display: flex;
//         justify-content: center;
//         margin-top: 10px;
//         font-size: 12px;

//         .five-item:nth-child(2) {
//           margin: 0 25px;
//         }

//         .five-item-title {
//           // font-weight: 700;
//           color: #000000;
//           font-size: 20px;
//         }
//       }
//     }
//   }

//   //产品介绍
//   .product {
//     img {
//       width: 100%;
//       height: 100%;
//     }

//     display: flex;
//     justify-content: center;
//     // background-color: aliceblue;
//     height: 280px;
//     padding: 0 20px;
//     // background-color: brown;

//     .box {
//       text-align: center;
//       width: 100%;
//       padding: 0;
//       // background-color: red;

//       .one {
//         // background-color: antiquewhite;
//         // text-align: center;
//         // background-color: aliceblue;
//         // line-height: 100px;
//         // width: 200px;
//         // height: 100px;

//         .title {
//           font-size: 20px;
//           color: #ff8714;
//           position: relative;

//           &::before {
//             content: ' ';
//             position: absolute;
//             display: block;
//             width: 5px;
//             height: 5px;
//             border-radius: 50%;
//             background-color: #ff8714;
//             top: 50%;
//             transform: translateY(-50%);
//             left: 34.2%;
//           }

//           &::after {
//             content: ' ';
//             position: absolute;
//             display: block;
//             width: 5px;
//             height: 5px;
//             border-radius: 50%;
//             background-color: #ff8714;
//             top: 50%;
//             transform: translateY(-50%);
//             right: 34.2%;
//           }
//         }
//       }

//       .two {
//         color: #a7a7a7;
//         font-size: 20px;
//         margin-bottom: 10px;
//         font-family: Fontsstyle1;
//         font-weight: 300;
//         // letter-spacing: 2px;
//       }

//       .content {
//         position: relative;

//         .content-top {
//           display: flex;
//           // justify-content: space-between;
//           height: 150px;
//           // width: 100%;
//           // opacity: 1;
//           display: none;

//           &.active {
//             // opacity: 1;

//             // height: 100px;
//             // width: 100%;
//             display: flex;
//             // display: block;
//           }

//           .left {
//             // flex: 1;
//             width: 595px;
//             height: 100%;

//             // img {
//             //   width: 100%;
//             //   height: 100%;
//             // }
//             // background-color: aqua;
//           }

//           .right {
//             width: 278px;
//             height: 100%;
//             // background-color: red;
//             display: flex;
//             flex-direction: column;
//             justify-content: center;

//             .right-text-box {
//               .right-title {
//                 font-size: 20px;
//                 margin-bottom: 5px;
//                 // margin-left: 135px;
//                 // line-height: 80px;
//                 // width: 100px;
//                 // height: 20px;
//                 // font-size: 16px;
//                 // font-weight: 700;
//                 // background-color: blue;
//               }

//               .line-box {
//                 display: flex;
//                 margin-left: 47px;
//                 // margin-left: 238px;

//                 .line1 {
//                   width: 9px;
//                   height: 1px;
//                   margin-right: 10px;
//                   background-color: #ff8714;
//                 }

//                 .line2 {
//                   width: 30px;
//                   height: 1px;
//                   background-color: #ff8714;
//                 }
//               }

//               .right-content {
//                 display: none;
//               }

//               .more {
//                 margin: 0 auto;
//                 margin-top: 20px;
//                 width: 50px;
//                 height: 25px;
//                 background-color: #ff8714;
//                 color: #fff;
//                 text-align: center;
//                 line-height: 25px;
//                 border-radius: 2px;
//                 font-size: 12px;
//                 cursor: pointer;

//                 &:hover {
//                   background-color: rgba(255, 135, 20, 0.8);
//                 }

//                 span {
//                   margin-left: 1px;
//                 }
//               }
//             }
//           }
//         }

//         .content-bottom {
//           display: flex;
//           // justify-content: center;
//           position: absolute;
//           align-items: center;
//           // left: 64px;
//           top: 170px;
//           left: 50%;
//           transform: translateX(-50%);
//           // height: 60px;

//           .content-bottom-item {
//             width: 40px;
//             height: 40px;
//             // background-color: green;
//             margin-right: 10px;
//             border-radius: 3px;
//             // border: 1px solid red;
//             display: flex;
//             align-items: center;

//             img {
//               // width: 100%;
//               // height: 100%;
//               width: 38px;
//               height: 38px;
//               // border-radius: 3px;
//               // object-fit: fill;
//             }

//             &.active {
//               border: 1px solid #ff8714;
//             }
//           }
//         }
//       }
//     }
//   }

//   //游戏视频
//   .video {
//     margin-top: 15px;
//     display: flex;
//     justify-content: center;
//     // background-color: red;
//     // height: 500px;
//     padding: 0 20px 0 20px;
//     // background-color: brown;

//     .box {
//       text-align: center;
//       width: 100%;
//       padding: 0;
//       // background-color: red;

//       .one {
//         // background-color: antiquewhite;
//         // text-align: center;
//         // background-color: aliceblue;
//         // line-height: 100px;
//         // width: 200px;
//         // height: 100px;

//         .title {
//           font-size: 20px;
//           color: #ff8714;
//           position: relative;

//           &::before {
//             content: ' ';
//             position: absolute;
//             display: block;
//             width: 5px;
//             height: 5px;
//             border-radius: 50%;
//             background-color: #ff8714;
//             top: 50%;
//             transform: translateY(-50%);
//             left: 34.2%;
//           }

//           &::after {
//             content: ' ';
//             position: absolute;
//             display: block;
//             width: 5px;
//             height: 5px;
//             border-radius: 50%;
//             background-color: #ff8714;
//             top: 50%;
//             transform: translateY(-50%);
//             right: 34.2%;
//           }
//         }
//       }

//       .two {
//         color: #a7a7a7;
//         font-size: 20px;
//         margin-bottom: 10px;
//         font-family: Fontsstyle1;
//         font-weight: 300;
//         // letter-spacing: 2px;
//       }

//       .content {
//         // display: flex;

//         .left {
//           position: relative;
//           width: 100%;
//           height: 500px;
//           // background-color: aqua;

//           .left-bottom-shadow {
//             position: absolute;
//             bottom: 0;
//             left: 0;
//             // width: 789px;
//             width: 100%;
//             height: 30px;
//             z-index: 999;
//             background-color: rgba(20, 42, 61, 0.3);

//             .title {
//               color: #fff;

//               font-size: 12px;
//               text-align: left;
//               line-height: 30px;
//               font-weight: 300;
//             }
//           }

//           .left-playIcon {
//             position: absolute;
//             top: 50%;
//             left: 50%;
//             transform: translate(-50%, -50%);
//             width: 50px;
//             height: 50px;

//             // background-color: red;
//             img {
//               width: 100%;
//               height: 100%;
//               cursor: pointer;
//             }
//           }
//         }

//         .right {
//           // display: flex;
//           width: 100%;
//           justify-content: space-between;
//           margin-top: 15px;
//           // width: 400px;
//           // // height: 150px;
//           // height: 100%;
//           // background-color: yellow;
//           // margin-left: 5px;

//           .right-top {
//             width: 100%;
//             height: 500px;
//             // background-color: burlywood;
//             margin-bottom: 15px;
//             // margin-right: 10px;
//             position: relative;

//             .left-bottom-shadow {
//               position: absolute;
//               bottom: 0;
//               left: 0;
//               // width: 789px;
//               width: 100%;
//               height: 30px;
//               z-index: 999;
//               background-color: rgba(20, 42, 61, 0.3);

//               .title {
//                 color: #fff;

//                 font-size: 12px;
//                 text-align: left;
//                 line-height: 30px;
//                 font-weight: 300;
//               }
//             }

//             .left-playIcon {
//               position: absolute;
//               top: 50%;
//               left: 50%;
//               transform: translate(-50%, -50%);
//               width: 50px;
//               height: 50px;

//               // background-color: red;
//               img {
//                 width: 100%;
//                 height: 100%;
//                 cursor: pointer;
//               }
//             }
//           }

//           .right-bottom {
//             width: 100%;
//             height: 500px;
//             // background-color: blue;
//             position: relative;

//             .left-bottom-shadow {
//               position: absolute;
//               bottom: 0;
//               left: 0;
//               // width: 789px;
//               width: 100%;
//               height: 30px;
//               z-index: 999;
//               background-color: rgba(20, 42, 61, 0.3);

//               .title {
//                 color: #fff;
//                 font-size: 12px;
//                 text-align: left;
//                 line-height: 30px;
//                 font-weight: 300;
//               }
//             }

//             .left-playIcon {
//               position: absolute;
//               top: 50%;
//               left: 50%;
//               transform: translate(-50%, -50%);
//               width: 50px;
//               height: 50px;

//               // background-color: red;
//               img {
//                 width: 100%;
//                 height: 100%;
//                 cursor: pointer;
//               }
//             }
//           }
//         }
//       }
//     }
//   }

//   //商务合作
//   .cooperation {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     // background-color: #036f9a;
//     background-image: linear-gradient(to right top, #0d496c, #047895, #01bdb0);
//     height: 150px;
//     margin: 15px 0;
//     letter-spacing: 4px;

//     // padding: 0 100px 0 100px;
//     // background-color: brown;
//     .box {
//       text-align: center;
//       padding: 0;

//       .textOne {
//         font-size: 20px;
//         font-family: Microsoft YaHei-Regular, Microsoft YaHei;
//         font-weight: 400;
//         color: rgba(255, 255, 255, 0.5);
//       }

//       .textTwo {
//         margin-top: -16px;
//         font-size: 20px;
//         font-family: Microsoft YaHei-Regular, Microsoft YaHei;
//         font-weight: 400;
//         color: #ffffff;
//       }

//       .btn {

//         // padding: 0;
//         .btn-box {
//           width: 86px;
//           height: 30px;
//           // margin: 20px 0;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           // justify-content: center;
//           background-color: #ff8714;
//           color: #ffebd8;
//           letter-spacing: 1px;
//           font-size: 12px;
//           border-radius: 3px;

//           .phone-icon {
//             width: 12px;
//             height: 12px;
//             margin: -8px 0 0 3px;

//             img {
//               width: 100%;
//               height: 100%;
//             }
//           }
//         }
//       }
//     }
//   }

//   // 通栏底部

//   .common-bottom {
//     height: 150px;
//     background-color: #ff8714;

//     .box {
//       display: none;
//     }

//     .mobile-box {
//       padding: 24px 0 0 0;
//       text-align: center;

//       .line {
//         // width: 1920px;
//         width: 100%;
//         height: 1px;
//         background: linear-gradient(225deg, rgba(255, 255, 255, 0) 0%, #ffffff 51%, rgba(255, 255, 255, 0) 100%);
//         // border-radius: 0px 0px 0px 0px;
//         opacity: 1;
//       }

//       .title {
//         color: #ffebd8;
//         font-size: 16px;
//         margin: 5px 0;
//       }

//       .textOne {
//         color: #ffebd8;
//         font-size: 10px;
//         transform: scale(0.83333);

//         // margin-bottom: 15px;
//       }

//       .textTwo {
//         color: #ffebd8;
//         font-size: 10px;
//         transform: scale(0.83333);
//       }
//     }
//   }
// }</style>
